import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface DayCardProps {
  day: number;
  title: string;
  description: string;
  index: number;
}
export function DayCard({
  day,
  title,
  description,
  index
}: DayCardProps) {
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1,
    duration: 0.5
  }} className="bg-night-800/50 border border-night-700 p-4 rounded-2xl relative overflow-hidden" data-id="element-6">
      <div className="absolute top-0 right-0 p-3 opacity-10" data-id="element-7">
        <span className="text-5xl font-serif font-bold text-lavender-400" data-id="element-8">
          {day}
        </span>
      </div>

      <div className="relative z-10" data-id="element-9">
        <div className="flex items-center gap-3 mb-2" data-id="element-10">
          <span className="bg-lavender-400/20 text-lavender-400 text-xs font-bold px-2 py-1 rounded-full" data-id="element-11">
            DÍA {day}
          </span>
          <h3 className="text-lg font-bold text-starlight-100" data-id="element-12">{title}</h3>
        </div>
        <p className="text-starlight-200/80 text-sm leading-relaxed" data-id="element-13">
          {description}
        </p>
      </div>
    </motion.div>;
}